import React, { useEffect, useState } from "react";
import ReferencesItem from "../../components/References/ReferencesItem";

const References = () => {
  const [descriptions, setDescriptions] = useState({});

  const getReferences = async () => {
    const response = await fetch("/references.json");
    const data = await response.json();
    setDescriptions(data);
  };

  useEffect(() => {
    getReferences();
  }, []);

  return (
    <div className="w-screen h-screen flex flex-col px-[5%] py-[5%] justify-center overflow-x-hidden">
      <div className="w-full h-full items-center gap-y-4 flex flex-col ">
        <h1 className="font-bold text-center text-xl sm:text-2xl pb-4 mt-8 sm:mt-0">
          Critérios/Análises técnicas e Referências do Dimensionamento de Rede
        </h1>
        {descriptions !== null && descriptions.length === 0 ? (
          <div className="flex flex-col w-full h-full justify-center items-center">
            <p className="text-center text-lg">Nenhuma referência encontrada</p>
          </div>
        ) : (
          <div className="flex flex-col gap-y-8 w-full pb-12">
            {Object.entries(descriptions).map(
              ([sectionTitle, items], index) => (
                <ReferencesItem
                  key={index}
                  item={sectionTitle}
                  descriptions={descriptions[sectionTitle]}
                />
              )
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default References;
